<common-card>
  <common-card-header>
    <h3>{{'modules.mission.mission_form.address_dialog.edit_address' | translate}} {{type === 'from' ? 'de départ' : "d'arrivée"}}</h3>
  </common-card-header>
  <common-card-body>
    <div class="col-12" [formGroup]="placeForm">
      <div>
        <label class="label">
          {{'modules.mission.mission_form.address_dialog.select_address' | translate}}
        </label>
        <pv-common-autocomplete
          formControlName="id"
          [selectItems]="availablePlaces"
          [displayTemplate]="customPlaceSelect"
          [placeholder]="'modules.order.place.select_place_placeholder' | translate"
          [newButton]="false"
          (dropDownClose)="closeTooltip()"
          (bottomReached)="loadMorePlaces()"
          (searchTextChanged)="onSearchChanged($event)"
        >
        </pv-common-autocomplete>
      </div>
      <div class="mt-2" *ngIf="selectedPlace && placeForm.get('id').value">
        <label class="label mb-0">
          {{'modules.mission.mission_form.address_dialog.address_info' | translate}}
        </label>
        <label class="label">
          {{selectedPlace.addresses[0].label}}
        </label>
      </div>
      <div class="col-12 d-flex align-items-center mt-3">
        <nb-checkbox formControlName="doNotChangeContact">
        </nb-checkbox>
        <label class="label ml-2 mb-1">
          {{'modules.mission.mission_form.address_dialog.do_not_change_contact' | translate}}
        </label>
      </div>
    </div>
  </common-card-body>
  <common-card-footer>
    <div class="row">
      <div class="col-12 text-right">
        <button nbButton status="primary" (click)="submit()">
          {{'global.button.submit' | translate}}
        </button>
      </div>
    </div>
  </common-card-footer>
</common-card>

<ng-template #customPlaceSelect let-item>
  {{item.name}} <ng-container *ngIf="item.customData?.global"><strong [nbTooltip]="globalTooltip">(GLOBAL)</strong></ng-container>
  <pv-no-address-warning *ngIf="!item.customData?.addressesCount || item.customData?.addressesCount === 0"
                         [clickShouldClose]="true"
                         class="position-relative ml-1">
  </pv-no-address-warning>
</ng-template>
